import store from '@/store';
import _ from 'lodash';

export const getCustomerInfo = (id, prefix) => {
	if (id) {
		const customers = _.get(
			store,
			'getters["options/OptionsCustomers"].items',
			[]
		);

		if (customers.length) {
			const customer = customers.find(c => c.value === id);
			if (customer) {
				const formatCustomerName = name => {
					if (prefix) {
						if (name.length > 14) {
							return name.substr(0, 14) + ' ...' + prefix;
						}
						
						prefix = ' ' + prefix;
					} else {
						prefix = '';
					}

					return name + prefix;
				};

				return {
					id: id,
					name: customer.text,
					nameFormatted: formatCustomerName(customer.text)
				};
			}
		}

		return {
			id: id,
			name: '',
			nameFormatted: ''
		};
	}

	return null;
};
